import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  clientId: string().required(),
})

export const url = ({ clientId }) => `/v1/clients/${clientId}`
